export const DEFAULT_DRAWDOWN_END_AGE = 90;
export const MAX_DRAWDOWN_AGE = 100;
export const MAXIMUM_TAX_FREE_CASH = 268275;
export const MINIMUM_STANDARD_OF_LIVING = 14233;
export const RETIREMENT_AGE = 67;
export const RETIREMENT_AGE_MAX = 74;
export const RETIREMENT_AGE_MIN = 55;
export const STATE_PENSION = 12547;
export const UPPER_AGE_THRESHOLD = 90;
export const BASIC_TAX_RATE = 0.2;
export const PERSONAL_ALLOWANCE_TAX = 12570;
